import React from 'react'
import './grayElement.scss'
var GrayElement =()=>{

	return(
			<div className="grayElement"></div>
		)
}

export default GrayElement